module.exports = __webpack_public_path__ + "img/bronze.81be929a.png";